export default "__VITE_ASSET__ce3fb4d3__"